/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { MemberManagementCreateMemberPointRequest } from '../models/MemberManagementCreateMemberPointRequest';
import type { MemberManagementCreateMemberPointResponseApiRespoonse } from '../models/MemberManagementCreateMemberPointResponseApiRespoonse';
import type { MemberManagementGetRemainPointRequest } from '../models/MemberManagementGetRemainPointRequest';
import type { MemberManagementGetRemainPointResponseApiRespoonse } from '../models/MemberManagementGetRemainPointResponseApiRespoonse';
import type { MemberManagementListMemberPointRequest } from '../models/MemberManagementListMemberPointRequest';
import type { MemberManagementListMemberPointResponseApiRespoonse } from '../models/MemberManagementListMemberPointResponseApiRespoonse';

import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';

export class MemberManagementMemberPointService {

    /**
     * ポイント一覧
     * @param requestBody
     * @returns MemberManagementListMemberPointResponseApiRespoonse 正常レスポンス
     * @throws ApiError
     */
    public static adminMemberPoint(
        requestBody: MemberManagementListMemberPointRequest,
    ): CancelablePromise<MemberManagementListMemberPointResponseApiRespoonse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/admin/member-point',
            body: requestBody,
            mediaType: 'applicatin/json',
            errors: {
                400: `Fail to process.`,
                401: `fail to authentication`,
                419: `token mismatch`,
            },
        });
    }

    /**
     * ポイントの新規登録
     * @param requestBody
     * @returns MemberManagementCreateMemberPointResponseApiRespoonse 正常レスポンス
     * @throws ApiError
     */
    public static adminMemberPointCreate(
        requestBody: MemberManagementCreateMemberPointRequest,
    ): CancelablePromise<MemberManagementCreateMemberPointResponseApiRespoonse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/admin/member-point/create',
            body: requestBody,
            mediaType: 'applicatin/json',
            errors: {
                400: `Fail to process.`,
                401: `fail to authentication`,
                419: `token mismatch`,
            },
        });
    }

    /**
     * Get remain points
     * @param requestBody
     * @returns MemberManagementGetRemainPointResponseApiRespoonse 正常レスポンス
     * @throws ApiError
     */
    public static adminMemberPointRemainPoints(
        requestBody: MemberManagementGetRemainPointRequest,
    ): CancelablePromise<MemberManagementGetRemainPointResponseApiRespoonse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/admin/member-point/remain_points',
            body: requestBody,
            mediaType: 'applicatin/json',
            errors: {
                400: `Fail to process.`,
                401: `fail to authentication`,
                419: `token mismatch`,
            },
        });
    }

}
